import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Button from "../../../Components/Button";
import PageHeader from "../../../Components/PageHeader";
import CreateAssessmentTemplateContainer from "../../../Container/CreateAssessmentTemplateContainer";
import { useAppDispatch, useAppSelector } from "../../../Store/Hooks";
import {
  createAssessmentTemplate,
  clearCreateTemplateSuccess,
} from "../../../Store/Reducers/AdminSlice";
import { CreateTemplateRequest } from "../../../Store/Reducers/AssessmentSlice";

const AdminCreateTemplate: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isCreatingTemplate, createTemplateSuccess } = useAppSelector(
    state => state.admin
  );

  useEffect(() => {
    if (createTemplateSuccess) {
      dispatch(clearCreateTemplateSuccess());
      navigate("/izba-admin?tab=config&subtab=templates");
    }
  }, [createTemplateSuccess, dispatch, navigate]);

  const handleBack = () => {
    navigate("/izba-admin?tab=config&subtab=templates");
  };

  const handleSubmit = async (payload: CreateTemplateRequest) => {
    await dispatch(createAssessmentTemplate(payload)).unwrap();
  };

  return (
    <div className="create-assessment-template-page bg-white overflow-hidden mt-3">
      <PageHeader
        title={
          <div className="header-title-with-back">
            <Button variant="clear" onClick={handleBack} className="back-btn">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.873 8.25L8.56925 13.9462L7.5 15L0 7.5L7.5 0L8.56925 1.05375L2.873 6.75H15V8.25H2.873Z"
                  fill="#5F6368"
                />
              </svg>
            </Button>
            Create Assessment Template
          </div>
        }
        breadcrumb={[
          { title: "Admin" },
          { title: "Templates" },
          { title: "Create Template" },
        ]}
      />
      <div className="w-full bg-white p-3 md:p-4">
        <div className="rounded-md bg-gray-100 p-4 md:p-4">
          <CreateAssessmentTemplateContainer
            onBack={handleBack}
            onSubmit={handleSubmit}
            isSubmitting={isCreatingTemplate}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminCreateTemplate;
